var map = {
	"./ItGoals/1.svg": 379,
	"./ItGoals/2.svg": 380,
	"./ItGoals/3.svg": 381,
	"./ItGoals/4.svg": 382,
	"./ItGoals/courses/ai.png": 540,
	"./ItGoals/courses/computer_literacy.png": 541,
	"./ItGoals/courses/frontend.png": 542,
	"./ItGoals/courses/game_design.png": 543,
	"./ItGoals/courses/gamedev.png": 544,
	"./ItGoals/courses/graphic_design.png": 545,
	"./ItGoals/courses/main.png": 546,
	"./ItGoals/courses/predprinimatelstvo.png": 547,
	"./ItGoals/courses/programming_basics.png": 548,
	"./ItGoals/courses/python.png": 549,
	"./ItGoals/courses/scratch.png": 550,
	"./ItGoals/courses/unity.png": 551,
	"./ItGoals/courses/video_content.png": 552,
	"./ItGoals/courses/videoblogging.png": 553,
	"./ItGoals/courses/web-razrabotka.png": 554,
	"./ItGoals/courses/webdev.png": 555,
	"./ItGoals/coursesNew/ai.png": 428,
	"./ItGoals/coursesNew/computer_literacy.png": 429,
	"./ItGoals/coursesNew/ege-informatika-desk.png": 355,
	"./ItGoals/coursesNew/ege-informatika.png": 356,
	"./ItGoals/coursesNew/frontend.png": 430,
	"./ItGoals/coursesNew/game_design.png": 431,
	"./ItGoals/coursesNew/graphic_design.png": 432,
	"./ItGoals/coursesNew/math-desk.png": 357,
	"./ItGoals/coursesNew/math.png": 358,
	"./ItGoals/coursesNew/predprinimatelstvo.png": 433,
	"./ItGoals/coursesNew/programming_basics.png": 434,
	"./ItGoals/coursesNew/python.png": 435,
	"./ItGoals/coursesNew/scratch.png": 436,
	"./ItGoals/coursesNew/unity.png": 437,
	"./ItGoals/coursesNew/videoblogging.png": 438,
	"./ItGoals/coursesNew/web-razrabotka.png": 439,
	"./ItGoals/cube.svg": 556,
	"./ItGoals/cursor1.svg": 350,
	"./ItGoals/cursor2.svg": 351,
	"./ItGoals/cursor3.svg": 352,
	"./ItGoals/cursor4.svg": 353,
	"./ItGoals/enter.svg": 557,
	"./ItGoals/globe.svg": 558,
	"./ItGoals/outbreak.svg": 559,
	"./ItGoals/puzzle.svg": 560,
	"./ItGoals/story1.png": 561,
	"./ItGoals/story2.png": 562,
	"./ItGoals/story3.png": 563,
	"./PlatformExample/PlatformLogo1.svg": 486,
	"./PlatformExample/PlatformLogo2.svg": 487,
	"./PlatformExample/PlatformLogo3.svg": 488,
	"./PlatformExample/PlatformLogo4.svg": 489,
	"./SK-base.svg": 802,
	"./SK-dark.svg": 803,
	"./achieve-yellow-big.svg": 536,
	"./achieve-yellow-small.svg": 538,
	"./alfa.svg": 804,
	"./application-form-background-mobile.png": 526,
	"./application-form-background.png": 525,
	"./arrowButton.svg": 347,
	"./arrowRight.svg": 689,
	"./components/footer/tg.svg": 484,
	"./components/footer/vk.svg": 482,
	"./components/footer/wa.svg": 483,
	"./components/header/tg.svg": 363,
	"./components/header/vk.svg": 361,
	"./components/header/wa.svg": 362,
	"./cross.svg": 533,
	"./cursor-desk.svg": 537,
	"./cursor-mobile.svg": 539,
	"./detail/ai/6.1.png": 611,
	"./detail/ai/6.2.png": 612,
	"./detail/ai/6.3.png": 613,
	"./detail/ai/6.svg": 459,
	"./detail/ai/7.svg": 443,
	"./detail/ai/line.3.svg": 614,
	"./detail/ai/line.svg": 364,
	"./detail/ai/logoPage.png": 413,
	"./detail/ai/logoPagePhone.png": 398,
	"./detail/ai/spanBorder.svg": 384,
	"./detail/arrow.svg": 441,
	"./detail/computernaya-gramotnost/6.1.png": 615,
	"./detail/computernaya-gramotnost/6.2.png": 616,
	"./detail/computernaya-gramotnost/6.3.png": 617,
	"./detail/computernaya-gramotnost/6.svg": 460,
	"./detail/computernaya-gramotnost/7.svg": 444,
	"./detail/computernaya-gramotnost/line.3.svg": 618,
	"./detail/computernaya-gramotnost/line.svg": 365,
	"./detail/computernaya-gramotnost/logoPage.png": 414,
	"./detail/computernaya-gramotnost/logoPagePhone.png": 399,
	"./detail/computernaya-gramotnost/spanBorder.svg": 385,
	"./detail/ege-informatika/6.1.png": 619,
	"./detail/ege-informatika/6.2.png": 620,
	"./detail/ege-informatika/6.3.png": 621,
	"./detail/ege-informatika/6.svg": 461,
	"./detail/ege-informatika/7.svg": 445,
	"./detail/ege-informatika/line.3.svg": 622,
	"./detail/ege-informatika/line.svg": 366,
	"./detail/ege-informatika/logoPage.png": 415,
	"./detail/ege-informatika/logoPagePhone.png": 400,
	"./detail/ege-informatika/spanBorder.svg": 354,
	"./detail/frontend/6.1.png": 623,
	"./detail/frontend/6.2.png": 624,
	"./detail/frontend/6.3.png": 625,
	"./detail/frontend/6.svg": 462,
	"./detail/frontend/7.svg": 446,
	"./detail/frontend/line.3.svg": 626,
	"./detail/frontend/line.svg": 367,
	"./detail/frontend/logoPage.png": 416,
	"./detail/frontend/logoPagePhone.png": 401,
	"./detail/frontend/spanBorder.svg": 386,
	"./detail/game-design/6.1.png": 627,
	"./detail/game-design/6.2.png": 628,
	"./detail/game-design/6.3.png": 629,
	"./detail/game-design/6.svg": 463,
	"./detail/game-design/7.svg": 447,
	"./detail/game-design/line.3.svg": 630,
	"./detail/game-design/line.svg": 368,
	"./detail/game-design/logoPage.png": 417,
	"./detail/game-design/logoPagePhone.png": 402,
	"./detail/game-design/spanBorder.svg": 387,
	"./detail/graphic-design-pro/6.1.png": 631,
	"./detail/graphic-design-pro/6.2.png": 632,
	"./detail/graphic-design-pro/6.3.png": 633,
	"./detail/graphic-design-pro/6.svg": 464,
	"./detail/graphic-design-pro/7.svg": 448,
	"./detail/graphic-design-pro/line.3.svg": 634,
	"./detail/graphic-design-pro/line.svg": 369,
	"./detail/graphic-design-pro/logoPage.png": 418,
	"./detail/graphic-design-pro/logoPagePhone.png": 403,
	"./detail/graphic-design-pro/spanBorder.svg": 388,
	"./detail/graphic-design/6.1.png": 635,
	"./detail/graphic-design/6.2.png": 636,
	"./detail/graphic-design/6.3.png": 637,
	"./detail/graphic-design/6.svg": 465,
	"./detail/graphic-design/7.svg": 449,
	"./detail/graphic-design/line.3.svg": 638,
	"./detail/graphic-design/line.svg": 370,
	"./detail/graphic-design/logoPage.png": 419,
	"./detail/graphic-design/logoPagePhone.png": 404,
	"./detail/graphic-design/spanBorder.svg": 389,
	"./detail/greenieLike.svg": 639,
	"./detail/intensive/6.1.png": 640,
	"./detail/intensive/6.2.png": 641,
	"./detail/intensive/6.3.png": 642,
	"./detail/intensive/6.svg": 466,
	"./detail/intensive/7.svg": 450,
	"./detail/intensive/line.3.svg": 643,
	"./detail/intensive/line.svg": 371,
	"./detail/intensive/logoPage.png": 420,
	"./detail/intensive/logoPagePhone.png": 405,
	"./detail/intensive/spanBorder.svg": 390,
	"./detail/line-mobile.svg": 442,
	"./detail/line.3.svg": 474,
	"./detail/line.svg": 440,
	"./detail/orangeLight.svg": 644,
	"./detail/osnovy-programmirovaniya/6.1.png": 645,
	"./detail/osnovy-programmirovaniya/6.2.png": 646,
	"./detail/osnovy-programmirovaniya/6.3.png": 647,
	"./detail/osnovy-programmirovaniya/6.svg": 467,
	"./detail/osnovy-programmirovaniya/7.svg": 451,
	"./detail/osnovy-programmirovaniya/line.3.svg": 648,
	"./detail/osnovy-programmirovaniya/line.svg": 372,
	"./detail/osnovy-programmirovaniya/logoPage.png": 421,
	"./detail/osnovy-programmirovaniya/logoPagePhone.png": 406,
	"./detail/osnovy-programmirovaniya/spanBorder.svg": 391,
	"./detail/predprinimatelstvo/6.1.png": 649,
	"./detail/predprinimatelstvo/6.2.png": 650,
	"./detail/predprinimatelstvo/6.3.png": 651,
	"./detail/predprinimatelstvo/6.svg": 468,
	"./detail/predprinimatelstvo/7.svg": 452,
	"./detail/predprinimatelstvo/line.3.svg": 652,
	"./detail/predprinimatelstvo/line.svg": 373,
	"./detail/predprinimatelstvo/logoPage.png": 422,
	"./detail/predprinimatelstvo/logoPagePhone.png": 407,
	"./detail/predprinimatelstvo/spanBorder.svg": 392,
	"./detail/purpleHeart.svg": 653,
	"./detail/python/6.1.png": 654,
	"./detail/python/6.2.png": 655,
	"./detail/python/6.3.png": 656,
	"./detail/python/6.svg": 469,
	"./detail/python/7.svg": 453,
	"./detail/python/line.3.svg": 657,
	"./detail/python/line.svg": 374,
	"./detail/python/logoPage.png": 423,
	"./detail/python/logoPagePhone.png": 408,
	"./detail/python/spanBorder.svg": 393,
	"./detail/scratch/6.1.png": 658,
	"./detail/scratch/6.2.png": 659,
	"./detail/scratch/6.3.png": 660,
	"./detail/scratch/6.svg": 470,
	"./detail/scratch/7.svg": 454,
	"./detail/scratch/line.3.svg": 661,
	"./detail/scratch/line.svg": 375,
	"./detail/scratch/logoPage.png": 424,
	"./detail/scratch/logoPagePhone.png": 409,
	"./detail/scratch/spanBorder.svg": 394,
	"./detail/unity/6.1.png": 662,
	"./detail/unity/6.2.png": 663,
	"./detail/unity/6.3.png": 664,
	"./detail/unity/6.svg": 471,
	"./detail/unity/7.svg": 455,
	"./detail/unity/line.3.svg": 665,
	"./detail/unity/line.svg": 376,
	"./detail/unity/logoPage.png": 425,
	"./detail/unity/logoPagePhone.png": 410,
	"./detail/unity/spanBorder.svg": 395,
	"./detail/videoblogging/6.1.png": 666,
	"./detail/videoblogging/6.2.png": 667,
	"./detail/videoblogging/6.3.png": 668,
	"./detail/videoblogging/6.svg": 472,
	"./detail/videoblogging/7.svg": 456,
	"./detail/videoblogging/line.3.svg": 669,
	"./detail/videoblogging/line.svg": 377,
	"./detail/videoblogging/logoPage.png": 426,
	"./detail/videoblogging/logoPagePhone.png": 411,
	"./detail/videoblogging/spanBorder.svg": 396,
	"./detail/web-razrabotka/6.1.png": 670,
	"./detail/web-razrabotka/6.2.png": 671,
	"./detail/web-razrabotka/6.3.png": 672,
	"./detail/web-razrabotka/6.svg": 473,
	"./detail/web-razrabotka/7.svg": 457,
	"./detail/web-razrabotka/line.3.svg": 673,
	"./detail/web-razrabotka/line.svg": 378,
	"./detail/web-razrabotka/logoPage.png": 427,
	"./detail/web-razrabotka/logoPagePhone.png": 412,
	"./detail/web-razrabotka/spanBorder.svg": 397,
	"./detail/yellowPalms.svg": 674,
	"./egeChildren.png": 524,
	"./firstSteps/1.png": 521,
	"./firstSteps/2.png": 522,
	"./firstSteps/3.png": 523,
	"./firstSteps1.png": 805,
	"./firstSteps2.png": 520,
	"./fotoTestimonialsCustomers.png": 806,
	"./gift1.svg": 499,
	"./gift2.svg": 500,
	"./globe-svg.svg": 383,
	"./globe.png": 807,
	"./green-thumb.png": 573,
	"./greenieLike.svg": 808,
	"./holiday1.svg": 501,
	"./holiday2.svg": 502,
	"./holiday3.svg": 503,
	"./holiday4.svg": 504,
	"./learning/learnGif1.gif": 567,
	"./learning/learnGif2.gif": 568,
	"./learning/learnGif3.gif": 569,
	"./learning/learnGif4.gif": 570,
	"./li/Blue.svg": 577,
	"./li/Green.svg": 578,
	"./li/LightCyan.svg": 579,
	"./li/Lime.svg": 580,
	"./li/NadeshikoPink.svg": 581,
	"./li/Pink.svg": 582,
	"./li/Purple.svg": 583,
	"./li/Sky.svg": 584,
	"./li/SpanishPink.svg": 585,
	"./li/Yellow.svg": 586,
	"./logoAlg.svg": 490,
	"./logoFix.svg": 518,
	"./logoFooter.svg": 534,
	"./logoFooterMobile.svg": 535,
	"./logoHeader.svg": 491,
	"./logoHeaderPc.svg": 492,
	"./logoNavPopUp.svg": 493,
	"./menuNav.svg": 809,
	"./ok.svg": 349,
	"./orangeLight.svg": 810,
	"./ozon.png": 811,
	"./phone.svg": 519,
	"./placeholder.png": 575,
	"./professor/professor1.png": 527,
	"./professor/professor2.png": 528,
	"./professor/professor3.png": 529,
	"./professor/professor4.png": 530,
	"./professor/professor5.png": 531,
	"./professor/professor6.jpg": 532,
	"./purpleHeart.svg": 812,
	"./red-fire.png": 572,
	"./rf.svg": 813,
	"./room/room1.jpg": 814,
	"./room/room2.jpg": 815,
	"./room/room3.jpg": 816,
	"./room/room4.jpg": 817,
	"./sk.svg": 818,
	"./skY.png": 819,
	"./star.svg": 507,
	"./stars.svg": 576,
	"./subtract.svg": 820,
	"./subtract2.svg": 821,
	"./tick.svg": 708,
	"./triangularRight.svg": 885,
	"./violet-heart.png": 571,
	"./yandex.png": 822,
	"./yellow-hello.png": 574,
	"./yellow-line-1-desc.svg": 564,
	"./yellow-line-2-desc.svg": 565,
	"./yellow-line-slider.svg": 566,
	"./yellowPalms.svg": 823
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 801;